import Service from './baseService';
import { getCompanyId, getModelTypeIdAndEntityId } from '../config';
import moment from 'moment';

export const getInvoicesService = (
    startDay = moment().startOf('day').subtract(1, 'days').format('YYYY-MM-DD HH:mm:ss'),
    endDay = moment().endOf('day').format('YYYY-MM-DD HH:mm:ss')
) => {
    return Service.get('/customer/invoices', { params: { startDay, endDay, ...getModelTypeIdAndEntityId() } });
};

export const getInvoicePaymentDetailsService = (id, ts) => {
    return Service.get(`/customer/invoices/payment/${id}`, { params: { ts, ...getModelTypeIdAndEntityId() } });
};

export const getInvoiceDetailService = (invoiceId) => {
    return Service.get(`/customer/invoices/${invoiceId}`, {
        params: { host: window.location.origin, ...getModelTypeIdAndEntityId() },
    });
};

export const printInvoiceService = (invoiceId, companyID) => {
    let params = {
        companyId: companyID || getCompanyId(),
        ...getModelTypeIdAndEntityId(),
    };
    return Service.post(`/customer/invoices/get-Print/${invoiceId}`, {}, { params, responseType: 'arraybuffer' });
};

export const getInvoiceTrasactionsService = (invoiceId) => {
    return Service.get(`/customer/invoices/transaction/${invoiceId}`, { params: getModelTypeIdAndEntityId() });
};
